/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIOfferFile
 */
export interface APIOfferFile {
    /**
     * 
     * @type {string}
     * @memberof APIOfferFile
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIOfferFile
     */
    offer: string;
    /**
     * 
     * @type {string}
     * @memberof APIOfferFile
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIOfferFile
     */
    document?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIOfferFile
     */
    readonly name: string;
    /**
     * 
     * @type {Date}
     * @memberof APIOfferFile
     */
    readonly storedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIOfferFile
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof APIOfferFile
     */
    readonly size: number;
}

/**
 * Check if a given object implements the APIOfferFile interface.
 */
export function instanceOfAPIOfferFile(value: object): value is APIOfferFile {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('offer' in value) || value['offer'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('storedAt' in value) || value['storedAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    return true;
}

export function APIOfferFileFromJSON(json: any): APIOfferFile {
    return APIOfferFileFromJSONTyped(json, false);
}

export function APIOfferFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIOfferFile {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'offer': json['offer'],
        'key': json['key'] == null ? undefined : json['key'],
        'document': json['document'] == null ? undefined : json['document'],
        'name': json['name'],
        'storedAt': (new Date(json['stored_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'size': json['size'],
    };
}

export function APIOfferFileToJSON(value?: Omit<APIOfferFile, 'self'|'name'|'stored_at'|'last_modified_at'|'size'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'offer': value['offer'],
        'key': value['key'],
        'document': value['document'],
    };
}

